import { Component, Input, OnInit } from '@angular/core';
import { AvailableServices, MeetingViewModelService } from '@vendasta/integrations';
import { Observable } from 'rxjs';
import { DisconnectMeetingIntegrationConfirmationDialogComponent } from '../disconnect-meeting-integration-confirmation-dialog/disconnect-meeting-integration-confirmation-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { take } from 'rxjs/operators';

@Component({
  selector: 'meeting-scheduler-connect-with-google-button',
  templateUrl: './connect-with-google-button.component.html',
  styleUrls: ['./connect-with-google-button.component.scss'],
  standalone: false,
})
export class ConnectWithGoogleButtonComponent implements OnInit {
  @Input() serviceKey: string;
  @Input() primaryDisconnect = true;
  @Input() isMeetingApp = false; // Explicitly indicate if this is for meeting app (true) or calendar (false)
  shouldTriggerDisconnect = false;
  signInKey: string;
  readonly disconnectKey = 'MEETING_SCHEDULER.MEETING_INTEGRATIONS.DISCONNECT_SERVICE';
  readonly disconnectSecondaryKey = 'MEETING_SCHEDULER.MEETING_INTEGRATIONS.DISCONNECT';
  readonly alreadyConnectedKey = 'MEETING_SCHEDULER.MEETING_INTEGRATIONS.CONNECTED';
  public readonly meet = AvailableServices.GOOGLE_MEET;
  isConnected$: Observable<boolean>;

  constructor(
    private readonly meetingViewModelService: MeetingViewModelService,
    public dialog: MatDialog,
  ) {}

  ngOnInit(): void {
    this.isConnected$ = this.meetingViewModelService.isServiceConnected$(AvailableServices.GOOGLE_MEET);
    this.signInKey = this.isMeetingApp
      ? 'MEETING_SCHEDULER.MEETING_INTEGRATIONS.MEETING_APP_SIGN_IN'
      : 'MEETING_SCHEDULER.MEETING_INTEGRATIONS.GOOGLE_SIGN_IN';
  }

  openDisconnectDialog(event: MouseEvent): void {
    if (!this.shouldTriggerDisconnect) {
      event.preventDefault();
      event.stopImmediatePropagation();

      const dialogRef = this.dialog.open(DisconnectMeetingIntegrationConfirmationDialogComponent, {
        maxWidth: '600px',
        data: {
          titleKey: 'MEETING_SCHEDULER.MEETING_INTEGRATIONS.GOOGLE_DISCONNECT',
          disconnectLabel: 'MEETING_SCHEDULER.MEETING_INTEGRATIONS.DISCONNECT',
        },
      });

      dialogRef
        .afterClosed()
        .pipe(take(1))
        .subscribe((confirmed: boolean) => {
          if (confirmed) {
            this.shouldTriggerDisconnect = true;

            setTimeout(() => {
              (event.target as HTMLElement).dispatchEvent(new MouseEvent('click', { bubbles: true }));
            });
          }
        });

      return;
    }
  }
}
